export const PAYMENT_STRIPE_REQUEST = 'PAYMENT_STRIPE_REQUEST';
export const PAYMENT_STRIPE_SUCCESS = 'PAYMENT_STRIPE_SUCCESS';
export const PAYMENT_STRIPE_FAILD = 'PAYMENT_STRIPE_FAILD';

export const TRANSACTIONS_REQUEST = 'TRANSACTIONS_REQUEST';
export const TRANSACTIONS_SUCCESS = 'TRANSACTIONS_SUCCESS';
export const TRANSACTIONS_FAILD = 'TRANSACTIONS_FAILD';
